import { DeleteModalComponent } from './../components/delete-modal/delete-modal';
import { UsersPage } from './../pages/users/users';
import { AltaUsuarioPage } from './../pages/alta-usuario/alta-usuario';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { FichaMedicionPage } from '../pages/ficha-tabs/ficha-medicion/ficha-medicion';

import { StatusBar } from '@ionic-native/status-bar';
import { PacientesProvider } from '../providers/pacientes/pacientes';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ComponentsModule } from '../components/components.module';
import { DirectivesModule } from '../directives/directives.module';
import { PatientService } from '../services/patient.service';
import {  SDKModels, LoopBackAuth, InternalStorage, RoleApi, UsuarioRolApi, ConsultasSqlApi } from '../services/lbsdk';

import { FichaTabsPage } from '../pages/ficha-tabs/ficha-tabs';
import { FichaPhotoRecettePage } from '../pages/ficha-tabs/ficha-photo-recette/ficha-photo-recette';
import { FichaPhotoModelPage } from '../pages/ficha-tabs/ficha-photo-model/ficha-photo-model';
import { FichaDataPacientPage } from '../pages/ficha-tabs/ficha-data-pacient/ficha-data-pacient';
import { PaginationComponent } from 'ionic2-pagination';
import { SelectSearchableModule } from 'ionic-select-searchable';

import { LoginPage } from '../pages/login/login';
import { LoginService } from '../services/login.service';
import { CompaniesPage } from '../pages/companies/companies';
import { RecuperarContraseñaPage } from '../pages/recuperar-contraseña/recuperar-contraseña';
import { CompaniesProvider } from '../providers/companies/companies.provider';
import { UsuarioSucursalProvider } from '../providers/users/companies.provider';

import { CompanyPage } from '../pages/companies/company/company';
import { MyHttpLogInterceptor } from '../services/auth/http.interceptor';
import { AuthService } from '../services/auth/auth.service';
import { EmpresasPage } from '../pages/empresas/empresas';
import { ControlEmpresaPage } from '../pages/empresas/control-empresa/control-empresa';

import { Base64 } from '@ionic-native/base64';
import { UsuarioApi } from '../services/lbsdk';
import { EstadoApi } from '../services/lbsdk';
import { RolApi } from '../services/lbsdk';
import { MedicionApi } from '../services/lbsdk';
import { UsuarioSucursalApi } from '../services/lbsdk';
import { MedicionEstadoApi } from '../services/lbsdk';
import { PacienteApi } from '../services/lbsdk';
import { SucursalApi } from '../services/lbsdk';
import { EmpresaApi } from '../services/lbsdk';
import { ServiciosSharedService } from '../services/servicios-shared.service';

//import { Base64 } from '@ionic-native/base64';
// if you use typescript
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    AltaUsuarioPage,    
    LoginPage,
    CompaniesPage,
    CompanyPage,
    UsersPage,
    RecuperarContraseñaPage,
    FichaMedicionPage, FichaTabsPage, FichaPhotoRecettePage, FichaPhotoModelPage,
    FichaDataPacientPage, PaginationComponent,EmpresasPage,ControlEmpresaPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp), ComponentsModule, DirectivesModule, HttpClientModule, SelectSearchableModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    UsersPage,
    AltaUsuarioPage,
    RecuperarContraseñaPage,
    FichaMedicionPage,
    FichaTabsPage, FichaPhotoRecettePage, FichaPhotoModelPage, FichaDataPacientPage, LoginPage,
    CompaniesPage,
    CompanyPage,
    DeleteModalComponent,EmpresasPage,ControlEmpresaPage
  ],
  providers: [
    UsuarioApi,
    StatusBar,
    // SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler }, PacientesProvider, HttpClientModule, PatientService,
    SDKModels, LoopBackAuth, InternalStorage, EstadoApi, LoginService,
     CompaniesProvider, UsuarioSucursalProvider,
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpLogInterceptor, multi: true }, AuthService,
     RoleApi,Base64,RolApi,MedicionApi,UsuarioSucursalApi,MedicionEstadoApi,PacienteApi,SucursalApi,EmpresaApi,UsuarioRolApi,
     ServiciosSharedService,ConsultasSqlApi


  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts